import _ from 'underscore';
import BackboneCompatibility from '../lib/backbone_compatibility';

const delegateEventSplitter = /^(\S+)\s*(.*)$/;

class View extends BackboneCompatibility {
  constructor(props = {}) {
    super(props);
    this.cid = _.uniqueId('view');
    this.tagName = 'div';
    this.options = props;
    _.mapObject(props, (val, key) => (this[key] = val));
    this._ensureDefaultElement();
    this._ensureElement();
    this.beforeFilter();
    this.initialize(props);
    this._draw();
  }

  $(selector) {
    return this.$el.find(selector);
  }

  _ensureElement() {
    var attrs;

    if (!this.el) {
      attrs = _.extend({}, _.result(this, 'attributes'));
      if (this.id) {
        attrs.id = _.result(this, 'id');
      }
      if (this.className) {
        attrs['class'] = _.result(this, 'className');
      }
      this.setElement(this._createElement(_.result(this, 'tagName')));
      this._setAttributes(attrs);
    } else {
      this.setElement(_.result(this, 'el'));
    }
  }

  _setAttributes(attr) {
    this.$el.attr(attr);
  }

  _createElement(tagName) {
    return document.createElement(tagName);
  }

  _draw() {
    this.waitRender(() => {
      this.beforeRender();
      this.render();
      this.afterRender();
    });
  }

  _destroy() {
    this.remove();
    this.destroy();
  }

  setElement(element) {
    this.undelegateEvents();
    this._setElement(element);
    this.delegateEvents();
  }

  _setElement(el) {
    this.$el = el instanceof window.$ ? el : window.$(el);
    this.el = this.$el[0];
  }

  _getEvents() {
    const events = _.result(this, 'events');

    return typeof events !== 'undefined' ? events : {};
  }

  undelegateEvents() {
    if (this.$el) {
      this.$el.off(`.delegateEvents${this.cid}`);
    }
  }

  delegateEvents() {
    const events = this._getEvents();
    let match;

    Object.keys(events).forEach((key) => {
      if (!_.isFunction(this[events[key]])) {
        return;
      }
      match = key.match(delegateEventSplitter);
      this.delegate(match[1], match[2], _.bind(this[events[key]], this));
    });
  }

  delegate(eventName, selector, listener) {
    this.$el.on(`${eventName}.delegateEvents${this.cid}`, selector, listener);
  }

  // Adds a custom event outside of Backbone.js event notation
  delegateEventTo(element, event, selector, listener) {
    this.$el
      .find(element)
      .on(`${event}.delegateEvents${this.cid}`, selector, listener);
  }

  _removeElement() {
    this.$el.remove();
  }

  /**
   * @todo unnecessary call to undelegateEvents, since this method removes the event listeners attached that were
   *    already removed by the _removeElement() call. This code seems to misunderstand what it's being done in
   *    backbone.view (https://backbonejs.org/docs/backbone.html), which removes events in the object itself.
   */
  remove() {
    this._removeElement();
    this.undelegateEvents();
  }

  initialize() {
    // Do nothing, should be overriden
  }

  _ensureDefaultElement() {
    // Does nothing, should be overriden
  }

  beforeFilter() {
    // Do nothing, should be overriden
  }

  beforeRender() {
    // Do nothing, should be overriden
  }

  waitRender(done) {
    if (!done) {
      throw new Error('You bust provide a callback for beforeRender');
    }
    done();
    // Do nothing, should be overriden
  }

  afterRender() {
    // Do nothing, should be overriden
  }

  render() {
    // Do nothing, should be overriden
  }

  destroy() {
    // Do nothing, should be overriden
  }

  error() {
    this._setElement(this.el);
    this._draw();
  }
}

module.exports = View;
